import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';
import { ApprovedContent } from './getApprovedContentData';

export default function useManageApprovedContent() {
  const publish = async (
    manualId: string,
    data: ApprovedContent,
    callback?: () => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexiverse-manual-api/v1/manuals/${manualId}/issue-changes`;
    await fetcher({
      url,
      method: 'post',
      body: {
        changes: data.map((x) => ({
          id: x.id,
          changeSetSeverity: x.changeSetSeverity || 'MINOR',
          type: x.contentType,
        })),
      },
    })
      .then((data) => {
        if (callback) callback();
      })
      .catch((err) => {
        console.warn('update err', err);
        if (onError) handleError(err, { onError });
      });
  };

  return {
    publish,
  };
}
